<template>
  <div>
    <el-upload
      class="upload-demo"
      :action="uploadConfig.action"
      :file-list="uploadConfig.fileList"
      :limit="uploadConfig.limit"
      :accept="uploadConfig.accept"
      :before-upload="beforeUpload"
      :on-exceed="onExceed"
      :on-remove="onRemove"
      :auto-upload="true"
      :http-request="onHttpRequest"
    >
      <el-button size="small" type="primary">点击上传</el-button>
      <div slot="tip" class="el-upload__tip">
        <el-progress
          v-show="progressVisible"
          :text-inside="true"
          :stroke-width="26"
          :percentage="percentage"
        ></el-progress>
        <div class="text">只能上传mp4文件，且不超过300M</div>
      </div>
    </el-upload>
  </div>
</template>

<script>
import { getFileType } from "@/utils/file-type.js";
import { fetchUploadVideo, fetchMergeFile } from "@/request/api_index.js";
import { createMD5 } from "@/utils/tool.js";
import axios from "axios";
import { captureFrame } from "./captureFrame.js";

export default {
  data() {
    return {
      uploadConfig: {
        action: "",
        fileList: [],
        accept: ".mp4",
        limit: 3
      },
      progressVisible: false,
      percentage: 0,
      currentFileInfo: {},
      progressArr: [], // 文件上传进度的数组，单项就是一个分片进度
      filehash: "",
      taskList: [],
      totalSize: 0,
      loading: null,
    };
  },

  methods: {
    async beforeUpload(file) {
      console.log("beforeUpload", file);
      if (!this.checkFileSize(file)) {
        // 上传前的操作
        return Promise.reject();
      }
      let fileInfo = await this.checkFileType(file);
      this.loading = this.$loading({
        lock: true,
        text: "解析文件中...",
        spinner: "el-icon-loading"
        // background: "rgba(0, 0, 0, 0.7)"
      });
      console.log('文件信息', fileInfo)
      try {
        let frame = await captureFrame(file, 1);
        this.$emit("getVideoimage", frame);
      } catch (error) {
        this.$message({
          message: "视频解析失败",
          type: "warning"
        });
      }
      console.log(fileInfo);
      return true;
    },
    checkFileSize(file) {
      const maxSize = 1024 * 1024 * 700;
      if (file.size > maxSize) {
        this.$message({
          message: "文件大小不能超过700M",
          type: "warning"
        });
        return false;
      }
      return true;
    },
    async checkFileType(file) {
      const res = await getFileType(file);
      this.currentFileInfo = res;
      
      console.log(res);
      if (res.mime !== "video/mp4") {
        this.$message({
          message: "请上传视频文件",
          type: "warning"
        });
        return Promise.reject();
      } else {
        this.currentFileInfo.ext = 'mp4'
        return res;
      }
    },

    onExceed() {
      this.$message.closeAll();
      this.$message({
        message: "最多选择1个视频文件",
        type: "warning"
      });
    },
    onRemove(file, filelist) {
      console.log(file, filelist);
      this.cancelTasks();
      this.setProgress(0);
      this.$emit("update:value", []);
      this.progressVisible = false;
    },
    async onHttpRequest(option) {
      console.log("onHttpRequest", option);
      this.progressArr = []; // 上传之前清空进度数组
      let tasks = await this.loadFile(option.file);
      this.loading.close();
      this.handRequestTask(tasks);
    },

    // 解析文件
    async loadFile(file) {
      const chunkSize = 1024 * 1024 * 2;
      let md5 = await createMD5(file, chunkSize);
      let chunkNum = Math.ceil(file.size / chunkSize); // 分片总数
      let fileChunkedList = []; // 文件分片完成之后的数据
      this.totalSize = file.size;
      this.filehash = md5;
      for (let i = 0; i < chunkNum; i++) {
        let cancelToken = axios.CancelToken;
        let source = cancelToken.source();
        let start = i * chunkSize;
        let end = start + chunkSize;
        fileChunkedList.push({
          index: i,
          file: file.slice(start, end),
          fileName: file.name,
          chunkNum: chunkNum,
          hash: md5,
          source: source
        });
        this.progressArr.push(0);
      }
      this.taskList = fileChunkedList;
      return fileChunkedList;
    },

    // 并发上传
    async handRequestTask(fileChunks, limit = 3) {
      console.log("handRequestTask");
      this.progressVisible = true;
      let POOL = [];
      for (let file of fileChunks) {
        let formdata = new FormData();
        formdata.append("file", file.file);
        formdata.append("chunks", file.chunkNum);
        formdata.append("chunk", file.index);
        formdata.append("guid", file.hash);
        formdata.append("extension", this.currentFileInfo.ext);

        let uploadTask = this.createUploadTask(
          formdata,
          file.index,
          file.source
        );
        uploadTask.then(res => {
          const index = POOL.findIndex(t => t === uploadTask);
          POOL.splice(index, 1);
        });
        POOL.push(uploadTask);
        if (POOL.length === limit) {
          await Promise.race(POOL);
        }
      }
      try {
        await Promise.all(POOL);
        let mergedata = await fetchMergeFile({
          data: {
            guid: this.filehash
          }
        });
        this.setProgress(100);
        let newlist = [
          {
            name: mergedata.data.name,
            url: mergedata.data.url,
            src: mergedata.data.url
          }
        ];
        this.progressVisible = false;
        this.$emit("update:value", newlist);
      } catch (err) {
        console.error(err);
        this.progressVisible = false;
      }
    },

    handleTask(uploadTask) {
      const index = POOL.findIndex(t => t === uploadTask);
      POOL.splice(index, 1);
    },

    createUploadTask(formdata, chunkIndex, source) {
      return new Promise((resolve, reject) => {
        fetchUploadVideo({
          data: formdata,
          cancelToken: source.token,
          isLoading: false,
          onUploadProgress: progressEvent => {
            this.handleUploadProgress(progressEvent, chunkIndex);
          }
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            if (err.code == 404) {
              resolve();
            } else {
              reject(err);
            }
          });
      });
    },

    handleUploadProgress(progressEvent, chunkIndex) {
      this.progressArr[chunkIndex] = progressEvent.loaded;
      let curTotal = this.progressArr.reduce(
        (total, curvalue) => total + curvalue,
        0
      );
      let progess = Math.floor((curTotal / this.totalSize) * 100);
      if (progess == 100) {
        this.setProgress(99);
      } else {
        this.setProgress(progess);
      }
    },
    setProgress(value) {
      this.percentage = value;
    },

    handleRemove(file) {
      console.log(file);
      this.$emit("update:value", []);
    },

    cancelTasks() {
      for (let task of this.taskList) {
        task.source.cancel("取消上传");
      }
    }
  },
  created() {},
  mouted() {}
};
</script>
<style scoped lang="less">
.file-box {
  .file-item {
    max-width: 800px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #ddd;
    border-radius: 10px;
    background-color: #fff;
    .name {
      flex: 1;
    }
    .icon {
      font-size: 30px;
      margin: 10px 10px;
    }
    .delete {
      padding: 10px;
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChunkUpload/index.vue